import { $, $$, $id, addEventListenerAll } from '../../../helper/utils';
import { MOBILMEDIA } from '../../../helper/constants';

const isRecipesOverview = document.body.classList.contains('recipes');
const header = $('#header');
const contentWrapper = $('.card-wrapper > .col-12');
const filters = $$('.filter');
const displayButtons = $$('.filter-display');
const showFilter = $('.show-filter');
const showFilterCount = $('.show-filter .filter-display-count');
const closeFilter = $('.close-filter');
const filterWrapper = $('.filter-wrapper');
const filterHeaderTitle = $('.filter-header h3');
const filterHeaderReset = $('.filter-header-reset');
const filterCloseApply = $('.filter-close-apply');
const filterHeaderText = filterHeaderTitle.textContent;
const closeApplyText = {
  close: filterCloseApply.textContent,
  apply: filterCloseApply.dataset.apply,
  back: filterCloseApply.dataset.back,
  show: filterCloseApply.dataset.show,
};
const articles = ['178749','173355','117085','198201','139937','101858','183251','169186','160677','100004','198198','103968','193086','108036','136251','179087','103237','103959','108037','108069','100202','125278','194872','173359','105877','110716','100178','173360','191858'];
let historyValues = {};
let filterInView = null;
let scrollTop = 0;
let filterChanged = false;
let timeout;

function changeListener() {
  const checkedFilters = filterInView.querySelectorAll('.checkbox:checked');

  if (checkedFilters.length > 0) {
    filterHeaderReset.disabled = false;

    if (MOBILMEDIA.matches) {
      filterCloseApply.firstElementChild.textContent = closeApplyText.apply;
    }
  } else if (checkedFilters.length === 0) {
    filterHeaderReset.disabled = true;

    if (MOBILMEDIA.matches) {
      filterCloseApply.firstElementChild.textContent = closeApplyText.back;
    }
  }

  filterChanged = true;
}

// add change listener to checkboxes
addEventListenerAll($$('.filter-form .checkbox'), 'change', changeListener);

// add filtered items to url, ecxept cateogries
function pushHistory(historyData) {
  const keys = Object.keys(historyData);
  let hashData = '';

  keys.forEach((key, index) => {
    if (key === 'specialWeek') {
      return;
    }
    const data = JSON.stringify(historyData[key]).replaceAll('"', '');
    if (index === 0) {
      hashData = `#${key}=${data}`;
    } else {
      hashData += `&${key}=${data}`;
    }
  });

  if (hashData === '') {
    window.history.replaceState({}, '', window.location.pathname);
  } else {
    window.history.pushState(null, null, hashData);
  }
}

async function sendFilterRequest(form, button, isSpecialWeek = false) {
  const requestBody = new FormData();
  const filterList = {};
  const activeFilters = form.querySelectorAll('.filter-item .checkbox:checked');
  // show loading indicator
  button.classList.add('loading');

  // check if special week is active then remove all other filters
  if (!isSpecialWeek) {
    // build object of active filters, grouped by their name
    for (const filter of activeFilters) {
      const name = filter.name.replace('[]', '');
      if (name in filterList === false) {
        filterList[name] = [];
      }
      filterList[name].push(filter.value);
    }

    // get additional form input values
    for (const input of form.children) {
      // skip if element isn't of type input
      if (input.nodeName !== 'INPUT') {
        continue;
      }
      requestBody.append(input.name, input.value);
    }

    // add filter IDs to FormData
    const filterNames = Object.keys(filterList);
    historyValues = {};
    if (filterNames.length === 0) {
      pushHistory(historyValues);
    }
    for (let i = 0; i < filterNames.length; i++) {
      const name = filterNames[i];
      // hide categories in url from category pages
      if (form.dataset.allrecipes === '1') {
        historyValues[name] = filterList[name].join();
      } else if (name !== 'categories') {
        historyValues[name] = filterList[name].join();
      }
      pushHistory(historyValues);
      for (const value of filterList[name]) {
        requestBody.append(`${name}[]`, value);
      }
    }
    $('.filter-wrapper').classList.remove('hidden');
  } else {
    requestBody.append('specialWeek', true);
    filterList['specialWeek'] = true;
    historyValues['specialWeek'] = true;
    for (const input of form.children) {
      // skip if element isn't of type input
      if (input.nodeName !== 'INPUT') {
        continue;
      }
      requestBody.append(input.name, input.value);
    }
    $('.filter-wrapper').classList.add('hidden');
  }
  try {
    const response = await fetch('/veo/ajaxRequest.php', { method: 'post', body: requestBody });
    const data = await response.json();
    // hide loading indicator
    button.classList.remove('loading');

    // hide all filters
    for (const filter of filters) {
      filter.classList.remove('show');
    }

    filterChanged = false;

    // replace html and sort by original order
    contentWrapper.innerHTML = data.data;
    const itemsWrapper = contentWrapper.children[0];
    const elements = Array.from(itemsWrapper.children);
    console.log(elements);
    elements.sort((a, b) => articles.indexOf(a.id.replace('pid', '')) - articles.indexOf(b.id.replace('pid', '')));
    console.log(elements);
    itemsWrapper.innerHTML = '';
    elements.forEach((e) => itemsWrapper.appendChild(e));

    // if content is filtered, show how many items are now displaying in mobile close button
    if (activeFilters.length > 0) {
      filterCloseApply.firstElementChild.textContent = `
      ${contentWrapper.querySelectorAll('.card-col').length} ${closeApplyText.show}
      `.trim();
    } else {
      filterCloseApply.firstElementChild.textContent = closeApplyText.close;
    }

    // update filter disabled state and label counts
    const responseFilterNames = Object.keys(data.filter);
    for (let i = 0; i < responseFilterNames.length; i++) {
      const name = responseFilterNames[i];

      for (const value of data.filter[name]) {
        console.log(value);
        if (value.id !== null) {
          const filterInput = $id(value.id);
          filterInput.disabled = value.count === 0;

          // update count
          const filterLabel = filterInput.nextElementSibling;
          filterLabel.textContent = filterLabel.textContent.replace(/\(\d+\)$/g, `(${value.count})`);
        }
      }
    }
  } catch (error) {
    console.error(error);
    button.classList.remove('loading');
  }
}

function applyFilter(filter, button, isSpecialWeek = false) {
  const form = filter.closest('form');
  const formFilters = form.querySelectorAll('.filter');
  const allActiveFilters = form.querySelectorAll('.filter-item .checkbox:checked');

  // update mobile show button count
  showFilterCount.textContent = allActiveFilters.length;

  // check if any filters are active
  if (allActiveFilters.length > 0) {
    // show counter in show button
    showFilterCount.style.display = 'inline-flex';
  } else {
    // hide counter in show button
    showFilterCount.style.display = 'none';
  }
  for (const filterEl of formFilters) {
    const activeFilters = filterEl.querySelectorAll('.checkbox:checked');
    const resetButton = filterEl.querySelector('.reset-filter');
    const activeFilterNames = [];
    const hasFilters = activeFilters.length > 0;

    // get filter names without count
    for (const el of activeFilters) {
      activeFilterNames.push(el.nextElementSibling.textContent.replace(/(\s\(\d+\))$/g, ''));
    }

    // build a comma seperated string with a & at the end
    const tp = activeFilterNames.join(', ');
    const li = tp.lastIndexOf(',');
    let selectedText = '';

    // just 1 active filter
    if (activeFilters.length === 1) {
      selectedText = tp;

      // multiple filters active
    } else if (hasFilters) {
      selectedText = `${tp.substr(0, li)} &${tp.substr(li + 1, tp.length)}`;
    }
    if (hasFilters) {
      filterEl.classList.add('has-selection');
    } else {
      filterEl.classList.remove('has-selection');
    }

    // update UI
    filterEl.querySelector('.filter-display-count').textContent = activeFilters.length;
    filterEl.querySelector('.filter-display-selected').textContent = selectedText;
    resetButton.firstElementChild.textContent = resetButton.firstElementChild.textContent
      .replace(/\s\(\d+\)$/, '')
      .concat(` (${activeFilters.length})`);
  }
  sendFilterRequest(form, button, isSpecialWeek);
}

// get filtered items from url, run ajax request to get filtered items
function getHistory() {
  const button = $('.filter-display');
  const { hash } = window.location;
  if (hash !== null && hash !== '') {
    const hashData = hash.substr(1).split('&');
    let splitedData = '';
    let isSpecialWeek = false;
    for (const data of hashData) {
      splitedData = data.split('=');
      if (splitedData !== null) {
        if (splitedData[0] === 'bbqWoche' && splitedData[1] === 'true') {
          isSpecialWeek = true;
          continue;
        }
        const value = splitedData[1].split(',');
        for (const item of value) {
          $(`#${item}`).checked = true;
        }
      }
    }
    applyFilter($('.apply-filter'), button, isSpecialWeek);
  }
}

getHistory();

function resetFilter(filter, button, skipRequest = false) {
  const filterItems = filter.querySelectorAll('.checkbox');

  // uncheck all
  for (const el of filterItems) {
    el.checked = false;
  }

  // update UI
  filter.classList.remove('has-selection');
  filter.querySelector('.filter-display-count').textContent = 0;
  filter.querySelector('.filter-display-selected').textContent = '';
  filterHeaderReset.disabled = true;
  filterCloseApply.firstElementChild.textContent = closeApplyText.back;
  button.firstElementChild.textContent = button.firstElementChild.textContent.replace(/\s\(\d+\)$/, '');

  // update mobile show button counter and hide it
  showFilterCount.textContent = 0;
  showFilterCount.style.display = 'none';

  if (skipRequest === false) {
    sendFilterRequest(filter.closest('form'), button);
  }
}

const timeline = gsap.timeline({
  paused: true,
  onReverseComplete() {
    // reset timeline and inline styles
    timeline.clear();
    gsap.set(displayButtons, { clearProps: 'all' });
  },
});

addEventListenerAll(filters, 'click', function (e) {
  const { target } = e;
  const display = this.firstElementChild;

  if (target === display || display.contains(target)) {
    // is mobile viewport
    if (MOBILMEDIA.matches) {
      // ignore click while tweening
      if (timeline.totalProgress() > 0 && timeline.totalProgress() < 1) {
        console.log('playing');
        return;
      }

      // update state
      filterInView = display.nextElementSibling;
      this.classList.add('show');

      // get checked checkboxes
      const checkedFilters = filterInView.querySelectorAll('.checkbox:checked');

      // update ui
      filterHeaderTitle.textContent = display.querySelector('.filter-display-title').textContent;
      if (checkedFilters.length > 0) {
        filterHeaderReset.disabled = false;

        if (filterChanged === true) {
          filterCloseApply.firstElementChild.textContent = closeApplyText.apply;
        } else {
          filterCloseApply.firstElementChild.textContent = closeApplyText.back;
        }
      } else {
        filterHeaderReset.disabled = true;
        filterCloseApply.firstElementChild.textContent = closeApplyText.back;
      }

      // add tweens
      timeline
        .to(displayButtons, {
          duration: 0.175,
          xPercent: -100,
          ease: 'sine.in',
        })
        .fromTo(filterInView, {
          xPercent: 100,
        }, {
          duration: 0.25,
          xPercent: 0,
          autoAlpha: 1,
          ease: 'sine.out',
        });

      // reset timeline speed to default and start
      timeline.timeScale(1);
      timeline.play();
    } else {
      requestAnimationFrame(() => {
        // is already visible, hide filters
        if (this.classList.contains('show')) {
          this.classList.remove('show');
          clearTimeout(timeout);
          timeout = null;

          // for mobile
          if ($('.filter.show') === null) {
            filterInView = null;
          }

          // show filters
        } else {
          this.classList.add('show');
          timeout = setTimeout(() => {
            this.querySelector('.checkbox').focus();
          }, 350);

          // for mobile
          filterInView = display.nextElementSibling;
        }
      });
    }
  } else if (target.classList.contains('apply-filter')) {
    applyFilter(this, target);
  } else if (target.classList.contains('reset-filter')) {
    resetFilter(this, target);
  }
}, { passive: true });

showFilter.addEventListener('click', () => {
  scrollTop = window.scrollY;

  requestAnimationFrame(() => {
    // hide header
    gsap.to(header, {
      duration: 0.1,
      autoAlpha: 0,
      ease: 'sine.in',
    });

    filterWrapper.classList.add('show');
  });

  setTimeout(() => {
    document.documentElement.classList.add('noscroll');
  }, 240);
}, { passive: true });

function closeFilterWrapper() {
  requestAnimationFrame(() => {
    window.scrollTo(0, scrollTop);
    document.documentElement.classList.remove('noscroll');
    filterWrapper.classList.remove('show');

    // show header
    gsap.to(header, {
      duration: 0.1,
      autoAlpha: 1,
      ease: 'sine.out',
    });
  });
}
closeFilter.addEventListener('click', closeFilterWrapper, { passive: true });

filterCloseApply.addEventListener('click', function () {
  if (filterInView === null) {
    closeFilterWrapper();
  } else {
    // ignore click while tweening
    if (timeline.totalProgress() > 0 && timeline.totalProgress() < 1) {
      console.log('playing');
      return;
    }

    const activeFilters = filterInView.closest('.filter-form').querySelector('.checkbox:checked');

    // update ui
    filterHeaderTitle.textContent = filterHeaderText;
    filterCloseApply.firstElementChild.textContent = closeApplyText.close;

    // enable global reset button if there is an active filter
    if (activeFilters !== null) {
      filterHeaderReset.disabled = false;
    }

    if (filterChanged === true) {
      applyFilter(filterInView.parentElement, this);
    }

    // update state
    filterInView = null;

    // make sure all filters are hidden in desktop view
    const visibleDesktopFilters = $$('.filter.show');
    for (const filter of visibleDesktopFilters) {
      filter.classList.remove('show');
    }

    // make reverse animations faster
    timeline.timeScale(1.25);
    timeline.reverse();
  }
}, { passive: true });

filterHeaderReset.addEventListener('click', function () {
  if (filterInView === null) {
    for (let i = 0; i < filters.length; i++) {
      if (i === filters.length - 1) {
        resetFilter(filters[i], this);
      } else {
        resetFilter(filters[i], this, true);
      }
    }
  } else {
    resetFilter(filterInView.parentElement, this);
  }
}, { passive: true });

// make filter input focus controllable via arrow keys
document.body.addEventListener('keydown', (e) => {
  if (e.target.classList.contains('checkbox') === false) {
    return;
  }

  if (e.key === 'ArrowDown') {
    e.preventDefault();

    const filterEl = e.target.closest('.filter-item');
    filterEl.nextElementSibling?.querySelector('.checkbox').focus();
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();

    const filterEl = e.target.closest('.filter-item');
    filterEl.previousElementSibling?.querySelector('.checkbox').focus();
  }
});

MOBILMEDIA.addListener((e) => {
  if (e.matches === false) {
    if (filterInView !== null) {
      timeline.progress(0);
    }

    gsap.set('.filter-items-wrapper', { clearProps: 'all' });
    // filterInView = null;
  } else if (filterInView !== null) {
    timeline.progress(1);
  }
});
